<template>
  <div class="step-four">
    <div class="form-group">
      <div class="clearfix">
        <label>
          9. CCS Reach & Segment Data (optional)
        </label>
        <div class="col-sm-6 pull-right text-right segment-btn">
          <button type="type" class="btn btn-primary" @click="addSegment">Add Segment</button>
          <button :disabled="CSSRich.columns.length < 3" type="type" class="btn btn-primary" @click="deleteSegment">Delete Segment</button>
        </div>
      </div>
      <HotTable :root="CSSRichId" ref="CSSRichId" :settings="CSSRich"></HotTable>
    </div>
    <div class="form-group">
      <label>
        10. CCS Size
      </label>
      <HotTable :root="CSSSizeId" ref="CSSSizeId" :settings="CSSSize"></HotTable>
    </div>
    <div v-bind:class="{ 'invalid-field': (!validate['step4']) }" v-bind:id="checkValidate = validate['step4']">
      <p class="error-msg">Please add valid entry in above table.</p>
    </div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import HotTable from 'vue-handsontable-official'
import Simplert from 'vue2-simplert'

export default {
  components: {
    HotTable,
    Simplert
  },
  props: ['inputData', 'createdObject', 'validate'],
  data () {
    return {
      ccsRichData: this.createdObject.ccs['table-data'],
      cssSizeData: this.createdObject.size_propensity['table-data'],
      addHeader: 1,
      checkValidate: '',
      CSSRichId: 'css-rich',
      CSSRich: {
        autoWrapRow: true,
        height: 250,
        colWidths: 150,
        data: [],
        colHeaders: [],
        allowInsertRow: false,
        className: 'esheetclass',
        outsideClickDeselects: false,
        invalidCellClassName: 'htInvalid',
        tableClassName: 'exceltablestyle ccstable createtable',
        fillHandle: {
          autoInsertRow: false
        },
        afterChange: this.CSSRichChanged,
        init: this.updateCCSRich,
        columns: []
      },
      CSSSizeId: 'css-size',
      CSSSize: {
        height: 130,
        colWidths: 150,
        data: [],
        colHeaders: [],
        allowInsertRow: false,
        className: 'esheetclass',
        invalidCellClassName: 'htInvalid',
        tableClassName: 'exceltablestyle ccstable createtable',
        fillHandle: {
          autoInsertRow: false
        },
        afterChange: this.CSSSizeChanged,
        init: this.updateCCSSize,
        columns: []
      }
    }
  },
  watch: {
    checkValidate: function (val) {
      if (!val) {
        this.$refs.CSSRichId.table.validateCells()
        this.$refs.CSSSizeId.table.validateCells()
      }
    }
  },
  activated () {
    let ccs = 0
    let loopVar = 1
    let ccsLength = this.CSSRich.data.length
    while (loopVar <= ccsLength - 1) {
      if (ccs < 0) {
        ccs = 0
      }
      if (this.ccsRichData['Channels'][ccs] !== undefined) {
        if (this.CSSRich.data[ccs + 1][0] !== this.ccsRichData['Channels'][ccs]) {
          this.$refs.CSSRichId.table.alter('remove_row', ccs + 1)
          --ccs
        } else {
          ++ccs
        }
      } else {
        this.$refs.CSSRichId.table.alter('remove_row', ccs + 1)
      }
      loopVar++
    }
    for (let ccsAdd in this.ccsRichData['Channels']) {
      if (this.CSSRich.data[parseInt(ccsAdd) + 1] === undefined) {
        this.$refs.CSSRichId.table.alter('insert_row', parseInt(ccsAdd) + 1)
        this.CSSRich.data[parseInt(ccsAdd) + 1][0] = this.ccsRichData['Channels'][ccsAdd]
      }
    }
  },
  methods: {
    updateCCSRich () {
      this.CSSRich.data = []
      let counter = 1
      for (let key in this.ccsRichData) {
        if (this.CSSRich.columns.length < Object.keys(this.ccsRichData).length) {
          this.CSSRich.colHeaders.push(key)
          if (counter === 1) {
            this.CSSRich.columns.push({readOnly: true})
          } else {
            this.CSSRich.columns.push({readOnly: false, validator: /^(((\d{1,3})(,\d{2})*)|(\d+))(.\d+)?$/})
          }
        }
        counter++
        for (let value in this.ccsRichData[key]) {
          if (this.CSSRich.data[value] === undefined) {
            this.CSSRich.data.push([])
          }
          this.CSSRich.data[value].push(this.ccsRichData[key][value])
        }
      }
      this.CSSRich.data.unshift(this.CSSRich.colHeaders)
    },
    updateCCSSize () {
      this.CSSSize.data = []
      let counter = 1
      for (let key in this.cssSizeData) {
        if (this.CSSSize.columns.length < Object.keys(this.cssSizeData).length) {
          this.CSSSize.colHeaders.push(key)
          if (counter === 1) {
            this.CSSSize.columns.push({readOnly: true})
          } else {
            this.CSSSize.columns.push({readOnly: false})
          }
        }
        counter++
        for (let value in this.cssSizeData[key]) {
          if (this.CSSSize.data[value] === undefined) {
            this.CSSSize.data.push([])
          }
          this.CSSSize.data[value].push(this.cssSizeData[key][value])
        }
      }
      this.CSSSize.data.unshift(this.CSSSize.colHeaders)
    },
    CSSRichChanged (changes, source) {
      for (let key in changes) {
        let colName = this.CSSRich.colHeaders[changes[key][1]]
        let index = changes[key][0]
        if (changes[key][0] !== 0) {
          index = index - 1
          let richValue = changes[key][3]
          if (richValue !== '' && richValue !== undefined) {
            richValue = richValue.replace(/,/gi, '')
            this.ccsRichData[colName][index] = richValue
          } else {
            this.ccsRichData[colName][index] = richValue
          }
        } else {
          if (this.ccsRichData.hasOwnProperty(changes[key][2])) {
            let keyValue = this.ccsRichData[changes[key][2]]
            delete this.ccsRichData[changes[key][2]]
            this.ccsRichData[changes[key][3]] = keyValue
          }
        }
      }
      if (changes) {
        this.$emit('stepValidate')
      }
    },
    CSSSizeChanged (changes, source) {
      for (let key in changes) {
        let colName = this.CSSSize.colHeaders[changes[key][1]]
        let index = changes[key][0]
        if (changes[key][0] !== 0) {
          index = index - 1
          let sizeValue = changes[key][3]
          if (sizeValue !== '' && sizeValue !== undefined) {
            sizeValue = sizeValue.replace(/,/gi, '')
            this.cssSizeData[colName][index] = sizeValue
          } else {
            this.cssSizeData[colName][index] = sizeValue
          }
        } else {
          if (this.cssSizeData.hasOwnProperty(changes[key][2])) {
            let keyValue = this.cssSizeData[changes[key][2]]
            delete this.cssSizeData[changes[key][2]]
            this.cssSizeData[changes[key][3]] = keyValue
          }
        }
      }
      if (changes) {
        this.$emit('stepValidate')
      }
    },
    addSegment () {
      if (this.CSSRich.columns.length < 12) {
        let segmentName = 'Segment ' + this.addHeader
        this.CSSRich.columns.push({readOnly: false, validator: /^(((\d{1,3})(,\d{2})*)|(\d+))(.\d+)?$/})
        this.CSSSize.columns.push({readOnly: false, validator: /^(((\d{1,3})(,\d{2})*)|(\d+))(.\d+)?$/})
        this.CSSRich.colHeaders.push(segmentName)
        this.CSSSize.colHeaders.push(segmentName)
        this.ccsRichData[segmentName] = []
        this.cssSizeData[segmentName] = []
        ++this.addHeader
      }
    },
    deleteSegment () {
      if (this.CSSRich.columns.length > 2) {
        let removeItem = this.$refs.CSSRichId.table.getSelected()
        if (removeItem !== undefined && removeItem[1] > 1) {
          var that = this
          let confirmDelete = {
            title: '',
            message: 'Are you sure to delete?',
            type: 'info',
            useConfirmBtn: true,
            customConfirmBtnText: 'Yes',
            customCloseBtnText: 'No',
            customConfirmBtnClass: 'btn btn-primary',
            customCloseBtnClass: 'btn btn-primary',
            onConfirm: function () {
              let colName = that.CSSRich.colHeaders[removeItem[1]]
              that.CSSRich.colHeaders.splice(removeItem[1], 1)
              that.CSSRich.columns.splice(removeItem[1], 1)
              that.CSSSize.colHeaders.splice(removeItem[0] - 1, 1)
              that.CSSSize.columns.splice(removeItem[0] - 1, 1)
              delete that.ccsRichData[colName]
              delete that.cssSizeData[colName]
            }
          }
          this.$refs.simplert.openSimplert(confirmDelete)
        } else {
          let deleteCol = {
            title: '',
            message: 'Please select CCS Rich Segment Column to delete',
            type: 'error',
            customCloseBtnClass: 'btn btn-primary'
          }
          this.$refs.simplert.openSimplert(deleteCol)
        }
      }
    }
  }
}
</script>
<style>
  .handsontable .ccstable tr:first-child td.esheetclass {
    background: #000 !important;
    color:#fff;
    font-weight: bold;
    padding: 4px;
    text-align: center;
  }
  .handsontable .ccstable thead th {
      display: none;
  }
  .handsontable .ccstable tr td.esheetclass:first-child {
    text-align: left !important;
  }
  .handsontable .ccstable tbody tr:first-child td.esheetclass:first-child, .handsontable .ccstable tbody tr td.esheetclass{
    text-align: center !important;
  }
  .segment-btn .btn-primary, .segment-btn .btn-primary:focus {margin: 0 0 10px 0; width: auto;}
  .simplert button.btn.btn-primary {
    margin: 0;
    width: auto;
}
</style>



// WEBPACK FOOTER //
// Model-four.vue?58707f1d